import React, { useState,useEffect } from 'react';
import N3rveLogo from './../../../../images/N3rveLogo.png'
import N3rvousLogo from './../../../../images/nervouslogo.png'
import N3rvePlusLogo from './../../../../images/nervouspluslogo.png'
import N3rveProLogo from './../../../../images/nerveprologo.png'
import CheckCircle from './../../../../images/checkcircle.png'
import CrossIcon from './../../../../images/crossicon.png'
import GreenTick from './../../../../images/artistnamesubmitted.png'
import ExclamationMark from './../../../../images/exclamationmark.png'
import SwitchPlan1 from './../../../../images/switchpointimg1.png'
import SwitchPlan2 from './../../../../images/switchpointimg2.png'
import {useNavigate} from "react-router-dom";
import ReactModal from 'react-modal';
import './ChangePlan.css'
import { Link, useLocation } from 'react-router-dom';

function ChangePlan() {
  const [planSelect,setPlanSelect] = useState(2);
  const [btnClick,setBtnClick] = useState(2);
  const [downgradeToggle,setDowngradeToggle] = useState(false)
  const [confirmDowngradeToggle,setConfirmDowngradeToggle] = useState(false)
  const [downgradePopup,setDowngradePopup] = useState(false);
  const [upgradePopup,setUpgradePopup] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [toggleChangePlan,setToggleChangePlan] = useState(false)

  const HandleClick = (no) =>{
    setPlanSelect(no);
  }

  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })

  const toogleChangePlan = ()=>{
   setToggleChangePlan(false)
   }

  useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
   }
    window.addEventListener('resize', handleResize)
    return _ => {
      window.removeEventListener('resize', handleResize)
    }
  })

  useEffect(()=>{
   console.log("Email")
   // hidedashboard(false)
   // console.log(location.state.email)
   // toogleTaskbar(false)
  },[])

  function closeUpgradePopup(){
   setUpgradePopup(false)
  }

  function closeDowngradePopup(){
   setDowngradePopup(false)
  }

  return (
   <div>
    
         <div className={dimensions.width >= 768 && dimensions.width <1024?'SelectPlanContainer2Tablet':'SelectPlanContainer2Desktop'}>
            <img src={N3rveLogo} alt="Nerve Logo" className='N3rveLogo' style={{marginLeft:'2em'}}/>

       
       
         {
            !downgradeToggle && !confirmDowngradeToggle &&
            <div style={{marginLeft:'-10em'}}>
            <div className='settingsSelectPlanTxt'>Select Your Plan
            </div>
            <div className='settingsFindPlanTxt'>Find a plan suitable for your career</div>
            <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'0em',top:'-4.5em',cursor:'pointer'}} onClick={()=>setUpgradePopup(false)}/>
            {/* <img src={CrossIcon} style={{position:'absolute',left:'103em',top:'7em',cursor:'pointer'}} onClick={()=>{hidedashboard(true);ToggleChangePlan();}}/> */}
    
            <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',marginLeft:'11.5em'}} >
                {
                    planSelect === 1 &&
                    <div className='SettingsPlanCard' style={{ backgroundColor:'rgba(255,255,255,0.1)',border:'rgba(255,255,255,80%) solid 2px'}} >
                    <img src={N3rvousLogo} style={{width:'1.5em',height:'1.5em',marginLeft:'1.5em',marginTop:'2.5em',marginBottom:'0.5em'}}/>
                    <div className='SettingsPlanName'>N3RVous</div>
                    <div className='SettingsPlanDesc'>For the new artist</div>
                    <div className='SettingsPlanPrice'>Free</div>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                       <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                       <div className='PlanListItem'>Deliver to Social Media</div>
                    </div>
    
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                       <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                       <div className='PlanListItem'>Limited DSP Release</div>
                    </div>
    
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                       <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                       <div className='PlanListItem'>Take 90% of royalties</div>
                    </div>
    
                    <div className='DowngradeBtn' onClick={()=>setDowngradeToggle(true)}>
                         Downgrade
                     </div>
    
                   
                 </div>
                }
    
                {
                    planSelect !== 1 &&
                    <div className='SettingsPlanCard'  >
                    <img src={N3rvousLogo} style={{width:'1.5em',height:'1.5em',marginLeft:'1.5em',marginTop:'2.5em',marginBottom:'0.5em'}}/>
                    <div className='SettingsPlanName'>N3RVous</div>
                    <div className='SettingsPlanDesc'>For the new artist</div>
                    <div className='SettingsPlanPrice'>Free</div>
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                       <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                       <div className='PlanListItem'>Deliver to Social Media</div>
                    </div>
    
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                       <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                       <div className='PlanListItem'>Limited DSP Release</div>
                    </div>
    
                    <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                       <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                       <div className='PlanListItem'>Take 90% of royalties</div>
                    </div>
    
                    <div className='DowngradeBtn' onClick={()=>setDowngradeToggle(true)}>
                       Downgrade
                     </div>
    
             
                 </div>
                }
               
                {
                    planSelect === 2 &&
                    <div className='SettingsPlanCard' style={{ backgroundColor:'rgba(255,255,255,0.1)',border:'rgba(255,255,255,80%) solid 2px'}} >
                    <img src={N3rvePlusLogo} style={{width:'1.5em',height:'1.5em',marginLeft:'1.5em',marginTop:'2.5em',marginBottom:'0.5em'}}/>
                    {/* <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                        <img src={N3rvePlusLogo} alt="Nervous Logo" className='PlanLogo'/> 
                    </div> */}
                     <div className='SettingsPlanName'>N3RVE</div>
                     <div className='SettingsPlanDesc'>For the rising artist</div>
                     <span className='SettingsPlanPrice'>$19.99 <span style={{fontSize:'1rem'}}>/ year</span></span>
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Includes all benefits from N3RVous</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Brand Yourself</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Take 100% of royalties</div>
                     </div>
    
    
                     
                      <div className='CurrentPlanBtn'>
                      Current Plan
                      </div>
    
                    
                 </div>
                }
    
                {
                    planSelect !== 2 &&
                    <div className='SettingsPlanCard'>
                      <img src={N3rvePlusLogo} style={{width:'1.5em',height:'1.5em',marginLeft:'1.5em',marginTop:'2.5em',marginBottom:'0.5em'}}/>
                   
                     <div className='SettingsPlanName'>N3RVE</div>
                     <div className='SettingsPlanDesc'>For the rising artist</div>
                     <span className='SettingsPlanPrice'>$19.99 <span style={{fontSize:'1rem'}}>/ year</span></span>
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Includes all benefits from N3RVous</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Brand Yourself</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Take 100% of royalties</div>
                     </div>
    
                     <div className='CurrentPlanBtn'>
                      Current Plan
                      </div>
    
                 </div>
                }
    
                {
                    planSelect === 3 &&
                    <div className='SettingsPlanCard' style={{ backgroundColor:'rgba(255,255,255,0.1)',border:'rgba(255,255,255,80%) solid 2px'}} >
                      <img src={N3rveProLogo} style={{width:'1.5em',height:'1.5em',marginLeft:'1.5em',marginTop:'2.5em',marginBottom:'0.5em'}}/>
                     <div className='SettingsPlanName'>N3RVE Premier</div>
                     <div className='SettingsPlanDesc'>For the breakout artist</div>
                     <span className='SettingsPlanPrice'>$49.99 <span style={{fontSize:'1rem'}}>/ year</span></span>
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Includes all benefits from Nerve</div>
                     </div>
                     
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Unlimited DSP Release</div>
                     </div>
                   
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Youtube Monetization</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Exclusive Brand/Sync Deals</div>
                     </div>
    
                    
                      <div className='UpgradeBtn' onClick={()=>setUpgradePopup(true)}>
                      Select Plan
                      </div>
    
                     
                 </div>
                }
    
                {
                    planSelect !== 3 &&
                    <div className='SettingsPlanCard' >
                      <img src={N3rveProLogo} style={{width:'1.5em',height:'1.5em',marginLeft:'1.5em',marginTop:'2.5em',marginBottom:'0.5em'}}/>
                     <div className='SettingsPlanName'>N3RVE Premier</div>
                     <div className='SettingsPlanDesc'>For the breakout artist</div>
                     <span className='SettingsPlanPrice'>$49.99 <span style={{fontSize:'1rem'}}>/ year</span></span>
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Includes all benefits from Nerve</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Unlimited DSP Release</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1.15em'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Youtube Monetization</div>
                     </div>
    
                     <div style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                        <img src={CheckCircle} alt="Check circle" className='CheckCircleImg'/>
                        <div className='PlanListItem'>Exclusive Brand/Sync Deals</div>
                     </div>
    
                     <div className='UpgradeBtn' onClick={()=>setUpgradePopup(true)}>
                      Select Plan
                      </div>
                     
                 </div>
                }
                
            </div>
            </div>
         }


         {
            downgradeToggle &&  !confirmDowngradeToggle &&
            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                  <div className='DowngradeH1'>Are you sure?</div>
                  {planSelect===2 &&
                  <div>
                      <div className='DowngradeH2'>If you downgrade to the free N3RVOUS plan:</div>

                           <div style={{display:'flex',flexDirection:'column'}}>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1em'}}>
                                 <div className='ExclamationContainer'>
                                    <img src={ExclamationMark}/>
                                 </div>
                                 <div className='DowngradeMenuItem'>The tools to brand yourself will be deactivated</div>
                              </div>

                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1em'}}>
                                 <div className='ExclamationContainer'>
                                    <img src={ExclamationMark}/>
                                 </div>
                                 <div className='DowngradeMenuItem'>DSP release will be limited</div>
                              </div>

                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'3em'}}>
                                 <div className='ExclamationContainer'>
                                    <img src={ExclamationMark}/>
                                 </div>
                                 <div className='DowngradeMenuItem'>You will take only 90% of royalties</div>
                              </div>

                           
                           </div>
                  </div>
                  }

                  {planSelect===3 &&
                  <div>
                      <div className='DowngradeH2'>If you downgrade to the N3RVE plan: </div>

                           <div style={{display:'flex',flexDirection:'column'}}>
                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1em'}}>
                                 <div className='ExclamationContainer'>
                                    <img src={ExclamationMark}/>
                                 </div>
                                 <div className='DowngradeMenuItem'>The tools to brand yourself will be deactivated</div>
                              </div>

                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1em'}}>
                                 <div className='ExclamationContainer'>
                                    <img src={ExclamationMark}/>
                                 </div>
                                 <div className='DowngradeMenuItem'>DSP release will be limited</div>
                              </div>

                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'1em'}}>
                                 <div className='ExclamationContainer'>
                                    <img src={ExclamationMark}/>
                                 </div>
                                 <div className='DowngradeMenuItem'>You will take only 90% of royalties</div>
                              </div>

                              <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginBottom:'3em'}}>
                                 <div className='ExclamationContainer'>
                                    <img src={ExclamationMark}/>
                                 </div>
                                 <div className='DowngradeMenuItem'>Your new yearly cost will be $19.99, billed on <br/> your next cycle</div>
                              </div>

                           
                           </div>
                  </div>
                  }
                 

                  <div style={{display:'flex',flexDirection:'row',marginBottom:'3em'}}>
                        <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                           <div className='DowngradeOptions'>I have a question</div>
                           <div className='ContactSupportBtn'>Contact Support</div>
                        </div>

                        <div style={{backgroundColor:'rgba(255,255,255,60%)',width:'1px',marginLeft:'5em',marginRight:'5em'}}/>

                        <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                           <div className='DowngradeOptions'>Yes, I'm sure</div>
                           <div className='ConfirmDowngradeBtn'onClick={()=>setDowngradePopup(true)}>Downgrade Plan</div>
                        </div>
                     </div>

                  <div className='BackTxt' onClick={()=>setDowngradeToggle(false)}>
                     Never mind, take me back
                  </div>
            </div>
         }

         {
            confirmDowngradeToggle &&
            <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>

                  <img src={GreenTick} style={{width:'2.5em',height:'2.5em',marginTop:'20.68em'}}/>
                  <div className='DowngradeH1' style={{marginTop:'1em',fontWeight:'500'}}>You have downgraded to the N3RVE plan.</div>
                  
                  <div className='BackTxt' style={{marginTop:'2em',cursor:'default',marginBottom:'2em'}}>
                  You can now explore the N3RVE features.
                  </div>

                  <div className='ConfirmDowngradeBtn' style={{width:'20em',marginTop:'1em'}} onClick={()=>{navigate("/Dashboard", { state: { fromAccountPage: false,fromLogin:true}})}}>Go Home</div>
            </div>
         }
        
         </div>
      
      <ReactModal
          isOpen={upgradePopup}
          overlayClassName="Overlay"
          contentLabel="Example Modal"
          onRequestClose={closeUpgradePopup} // closes the modal when the user presses the escape key
          shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
          style={{
            content:{
              width:'34.125em',
              height:'28.125em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              justifyContent:'space-between',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)'
            }
          }}
        >
          <div className='LogoutPopupHeader' style={{marginTop:'1em',marginBottom:'0em'}}>
          Switch Plan Payment Details
          </div>
          

          <div className="MfaInputHeader" style={{marginTop:'0em'}}>
          If you switch your plan today:
         </div>

         <div style={{display:'flex',flexDirection:'column',width:'75%'}}>
            <div style={{display:'flex',flexDirection:'row',marginBottom:'1em'}}>
               <img src={SwitchPlan1} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
               <div className='SwitchPlanPoint'>Your plan will switch right away, gaining access to new perks</div>
            </div>

            <div style={{display:'flex',flexDirection:'row'}}>
               <img src={SwitchPlan2} style={{width:'2em',height:'2em',marginRight:'1em'}}/>
               <div style={{display:'flex',flexDirection:'column'}}>
                  <div className='SwitchPlanPoint'>Your plan will switch right away, gaining access to new perks</div>
                  <div className='SwitchPlanPointDesc'>For the rest of this billing cycle, you’ll be on a more expensive plan. To cover the price difference for those 30 days, you’ll get a one-time charge of approximately $6.99.</div>
               </div>
            </div>
         </div>
         
          
            <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer',backgroundColor:'#E91353',backgroundImage:'none',width:'90%'}} onClick={()=>{setUpgradePopup(false)}}>
            Confirm Switch
            <div className="PostLoginBtnOverlay"/>
         
          </div>
      </ReactModal>



      <ReactModal
          isOpen={downgradePopup}
          overlayClassName="Overlay"
          contentLabel="Example Modal"
          onRequestClose={closeDowngradePopup} // closes the modal when the user presses the escape key
          shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
          style={{
            content:{
              width:'34.125em',
              height:'15.625em',
              margin:'auto',
              backgroundImage:'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              justifyContent:'space-between',
              borderRadius:'8px',
              border:'0.5px solid rgba(255,255,255,25%)'
            }
          }}
        >
          <div className='LogoutPopupHeader'>
          Confirm Downgrade
          </div>
          <div className="MfaInputHeader">
          If you confirm and end your subscription now, you will lose access to your N3RVE Premier perks immediately.
         </div>
          <img src={CrossIcon} style={{height:'1.5em',width:'1.5em',position:'absolute',right:'1.5em',top:'1.5em',cursor:'pointer'}} onClick={()=>setDowngradePopup(false)}/>
          <div style={{display:'flex',alignSelf:'center'}}>
            <div className="GoBackBtn" style={{paddingTop:'0.55em',paddingBottom:'0.5em',marginRight:'1em',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}} onClick={()=>setDowngradePopup(false)}>
            Cancel
            </div>
            <div className="IUnderstandBtn" style={{height:'3em',cursor:'pointer',backgroundColor:'#E91353',backgroundImage:'none'}} onClick={()=>{setDowngradePopup(false);setConfirmDowngradeToggle(true)}}>
            Confirm Downgrade
            <div className="PostLoginBtnOverlay"/>
            </div>
          </div>
      </ReactModal>


    </div>
  );
}

export default ChangePlan;